var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserTick(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.0002 40.0001C49.2049 40.0001 56.6668 32.5382 56.6668 23.3334C56.6668 14.1287 49.2049 6.66675 40.0002 6.66675C30.7954 6.66675 23.3335 14.1287 23.3335 23.3334C23.3335 32.5382 30.7954 40.0001 40.0002 40.0001Z",
    stroke: "#F9B036",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3667 73.3333C11.3667 60.4333 24.2 50 40 50C43.2 50 46.3 50.4333 49.2 51.2333",
    stroke: "#F9B036",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3332 60.0001C73.3332 62.5001 72.6332 64.8667 71.3999 66.8667C70.6999 68.0667 69.7999 69.1334 68.7665 70.0001C66.4332 72.1001 63.3665 73.3334 59.9998 73.3334C55.1332 73.3334 50.8998 70.7334 48.5998 66.8667C47.3665 64.8667 46.6665 62.5001 46.6665 60.0001C46.6665 55.8001 48.5998 52.0334 51.6665 49.6001C53.9665 47.7668 56.8665 46.6667 59.9998 46.6667C67.3665 46.6667 73.3332 52.6334 73.3332 60.0001Z",
    stroke: "#F9B036",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7998 60L58.0998 63.3L65.1998 56.7334",
    stroke: "#F9B036",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserTick);
export default __webpack_public_path__ + "static/media/user-tick.18240002dd24033c6097602671855c3d.svg";
export { ForwardRef as ReactComponent };